import type { InvitationState, selectionWorkflow } from './selectionWorkflow'

export interface ParticipantRequirement {
  id: string
  kind: 'downloadable_file'
  label: string
  fieldId: string
  accessFieldId?: string
  required: boolean
  dueAt: string
  timeZone: string
  instructions: string
}

export interface Deliverable {
  requirementId: string
  requirementVersion: number
  revision: number
  url: string
  accessNote: string
  status: 'submitted' | 'needs_changes' | 'verified'
  submittedAt: string
  reviewedAt?: string
  reviewedBy?: string
  reviewNote?: string
  archiveLocation?: string
}

export interface FinalizationPreview {
  fingerprint: string
  recipients: Array<{
    submissionId: string
    name: string
    email: string
    alreadySent: boolean
    invitationState: InvitationState
  }>
  workflow: ReturnType<typeof selectionWorkflow>
  requirements: ParticipantRequirement[]
  packageBacked: boolean
  subject: string
  html: string
}

export function requirementDeadline(requirement: ParticipantRequirement): string {
  return (
    new Intl.DateTimeFormat('en-US', {
      dateStyle: 'long',
      timeStyle: 'short',
      timeZone: requirement.timeZone,
    }).format(new Date(requirement.dueAt)) + ` (${requirement.timeZone})`
  )
}
